import { createContext } from "react";

const UsersCheckBoxContext = createContext();
export default UsersCheckBoxContext;